import Actions from 'actions';

const initialState = Object.freeze({});

function optIn(state = initialState, action) {
  switch (action.type) {
    case Actions.OPT_IN_EVENT_REQUEST:
      return initialState;
    case Actions.OPT_IN_EVENT_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.OPT_IN_EVENT_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default optIn;
